(() => {
  const boot = () => {
    const popup = document.querySelector('[data-om-popup]');
    const cookies = document.querySelector('[data-om-cookies]');
    const newsletterForm = popup?.querySelector('#OpticMergeNewsletterForm');
    let captchaPrepared = false;
    const prepareCaptcha = () => {
      if (captchaPrepared || !newsletterForm || !window.Shopify?.captcha?.protect) return;
      try {
        window.Shopify.captcha.protect(newsletterForm);
        captchaPrepared = true;
      } catch {}
    };
    const resetSubmission = () => {
      const label = newsletterForm?.querySelector('[data-om-submit-label]');
      if (label?.dataset.original) label.textContent = label.dataset.original;
      newsletterForm?.removeAttribute('aria-busy');
    };
    newsletterForm?.addEventListener('submit', () => {
      const label = newsletterForm.querySelector('[data-om-submit-label]');
      if (!label) return;
      label.dataset.original ||= label.textContent;
      label.textContent = label.dataset.pending;
      newsletterForm.setAttribute('aria-busy', 'true');
      window.setTimeout(() => {
        resetSubmission();
        const status = newsletterForm.querySelector('[data-om-newsletter-status]');
        if (status) status.textContent = status.dataset.retry;
      }, 8000);
    });
    window.addEventListener('pageshow', resetSubmission);
    const seen = () => {
      try { return Number(localStorage.getItem('om-welcome-dismissed-until')) > Date.now(); }
      catch { return false; }
    };
    const markSeen = () => {
      try { localStorage.setItem('om-welcome-dismissed-until', String(Date.now() + 30 * 86400000)); }
      catch { }
    };
    popup?.querySelector('[data-om-copy-code]')?.addEventListener('click', async event => {
      try {
        await navigator.clipboard.writeText('OPTICWELCOME5');
        event.currentTarget.textContent = event.currentTarget.dataset.copied;
      } catch {
        const range = document.createRange();
        range.selectNodeContents(popup.querySelector('.om-welcome-code code'));
        window.getSelection()?.removeAllRanges();
        window.getSelection()?.addRange(range);
      }
    });
    const openPopup = (manual = false) => {
      if (!popup || popup.open || (!manual && (seen() || popup.hasAttribute('data-editor'))) || cookies?.open) return;
      popup.showModal();
      popup.querySelector('[data-om-popup-close]')?.focus({ preventScroll: true });
      prepareCaptcha();
    };
    const closePopup = () => {
      if (popup?.open) popup.close();
      markSeen();
    };
    document.querySelectorAll('[data-om-popup-open]').forEach(button => button.addEventListener('click', () => openPopup(true)));
    popup?.querySelectorAll('[data-om-popup-close]').forEach(button => button.addEventListener('click', closePopup));
    popup?.addEventListener('cancel', markSeen);
    popup?.addEventListener('click', event => {
      if (event.target !== popup) return;
      const r = popup.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closePopup();
    });
    if (popup?.querySelector('[data-om-newsletter-success], [data-om-newsletter-errors]')) {
      openPopup(true);
      markSeen();
    } else if (popup) {
      setTimeout(() => openPopup(), Number(popup.dataset.delay) || 1500);
    }
    document.querySelectorAll('[data-om-tracking-form]').forEach(form => form.addEventListener('submit', event => {
      event.preventDefault();
      const value = new FormData(form).get('tracking')?.toString().trim();
      if (value) window.open('https://t.17track.net/en#nums=' + encodeURIComponent(value), '_blank', 'noopener,noreferrer');
    }));
    let privacyReady = false;
    const showCookiePreferences = () => {
      if (!cookies) return;
      if (popup?.open) popup.close();
      if (!cookies.open) cookies.show();
    };
    document.querySelectorAll('[data-om-cookie-open]').forEach(button => button.addEventListener('click', showCookiePreferences));
    const setConsent = allow => {
      if (!privacyReady || !window.Shopify?.customerPrivacy) {
        const status = cookies?.querySelector('[data-om-cookie-status]');
        if (status) status.textContent = document.documentElement.dataset.omPrivacyUnavailable || 'Privacy preferences are temporarily unavailable. Please try again or contact us.';
        return;
      }
      window.Shopify.customerPrivacy.setTrackingConsent({analytics:allow,marketing:allow,preferences:allow}, result => {
        if (result?.error) {
          const status = cookies?.querySelector('[data-om-cookie-status]');
          if (status) status.textContent = document.documentElement.dataset.omPrivacyUnavailable || 'Privacy preferences could not be saved. Please try again.';
          return;
        }
        cookies?.close();
        setTimeout(() => openPopup(), 1500);
      });
    };
    document.querySelector('[data-om-cookie-reject]')?.addEventListener('click', () => setConsent(false));
    document.querySelector('[data-om-cookie-accept]')?.addEventListener('click', () => setConsent(true));
    if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}], error => {
        if (error) return;
        privacyReady = true;
        if (window.Shopify.customerPrivacy.shouldShowBanner?.()) showCookiePreferences();
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  else boot();
})();

